import { splitMainAndExtraAssignments } from '../../../productSchema/productTaxonomyUx'

export const PRODUCTS_TAXONOMY_FILTER = {
  all: 'all',
  assigned: 'assigned',
  missingMain: 'missingMain',
}

export const PRODUCTS_ACTIVE_FILTER = {
  all: 'all',
  active: 'active',
  inactive: 'inactive',
}

export function isProductArchived(product) {
  return product?.isArchived === true
}

export function filterProductsByTableFilters(
  products = [],
  {
    taxonomyFilter = PRODUCTS_TAXONOMY_FILTER.all,
    activeFilter = PRODUCTS_ACTIVE_FILTER.all,
  } = {}
) {
  return products.filter((product) => {
    const split = splitMainAndExtraAssignments(product)

    // Категоризовані: є валідна основна категорія
    if (taxonomyFilter === PRODUCTS_TAXONOMY_FILTER.assigned && !split.hasMain) return false
    // Без основної: немає валідної основної (порожні + orphan / без canonical)
    if (taxonomyFilter === PRODUCTS_TAXONOMY_FILTER.missingMain && split.hasMain) return false

    if (activeFilter === PRODUCTS_ACTIVE_FILTER.active && product.isActive !== true) return false
    if (activeFilter === PRODUCTS_ACTIVE_FILTER.inactive && product.isActive === true) return false

    return true
  })
}
